require('./ordersTable.less');
import {LoDashStatic} from "lodash";

const _ = <LoDashStatic>require('lodash');

class OrdersTableController {
    query = {
        limit: 100,
        page: 1,
        order: ''
    };
    filter = {
        filterText: "",
        active: false
    };
    tableDefinition;
    settings;
    tableContent;
    tableTitle;
    initiated;
    locationChangeListener;
    activeState;
    minimizedOnInit;
    minimized;

    constructor(private toastService, private $scope, private $location, private Orders, private $filter, private $state, private $mdDialog) {
        $scope.query = this.query;
        this.locationChangeListener = $scope.$on('$locationChangeSuccess', () => {
            this.setPaginationSettings()
        });
    }

    $onInit() {
        this.setPaginationSettings();
        this.settings = this.tableDefinition.settings;
        this.activeState = angular.copy(this.$state.current.name);
        this.tableContent = _.orderBy(this.tableContent, ['availableAlert', 'vip', 'orderNo'], ['asc', 'desc', 'asc']);
        this.minimized = this.minimizedOnInit;
        this.$scope.$watchCollection('query', (newValue) => {
            if (this.initiated && this.tableContent && this.activeState === this.$state.current.name) {
                this.settings.onPaginate(newValue);
            }
            this.initiated = true;
        });
    }

    setPaginationSettings() {
        const queryParams = this.$location.search();
        this.query.limit = queryParams.pageSize ? parseInt(queryParams.pageSize) : 100;
        this.query.page = queryParams.pageNo ? parseInt(queryParams.pageNo) + 1 : 1;
    }

    // Function returned is invoked for each day in month
    isHighlighted(order) {
        return (date) => {
            if (order.routeDays === 0) {
                return true;
            }
            const dayString = (date.getDay() || 7).toString(); // Sets sundays to 7 ( === 0)
            return order.routeDays.toString().includes(dayString);
        };
    };

    setFilterState(s) {
        this.filter.filterText = "";
        this.filter.active = s;
    }

    setAltered(order) {
        order.altered = true;
    };

    confirmDate(ev, order) {
        ev.stopPropagation();
        const parsedDate = this.$filter('date')(order.deliveryDate, 'yyyy-MM-dd');
        this.Orders.setConfirmationDate({orderNumber: order.orderNo, confirmationDate: parsedDate}, {}).$promise.then(
            (success) => {
                order.altered = false;
                this.toastService.showSimpleToast("Bekreftet dato har blitt satt!", 3000);
            },
            (error) => this.toastService.parseError(error)
        );
    }

    handleOrder(orderNo) {
        this.locationChangeListener();
        this.$state.go('loggedin.orders_orderdetails', {orderNo: orderNo});
    }

    stopProp(ev) {
        ev.stopPropagation();
    }

    confirmOrder(order, send?) {
        this.tableDefinition.settings.promise =
            this.Orders.confirmOrder({
                orderNumber: order.orderNo
            }, {}).$promise.then(() => {
                    order.confirmed = true;
                    if (send) {
                        this.sendConfirmation(order, true)
                    } else {
                        this.toastService.showSimpleToast('Ordren er bekreftet', 3000);
                    }
                }, (error) => {
                    this.toastService.parseError(error);
                }
            );
    }

    handleAction(action, order) {
        if (action == 'ConfirmAndSend') {
            this.confirmOrder(order, true);
        } else if (action == 'Confirm') {
            this.confirmOrder(order);
        } else if (action == 'Send') {
            this.sendConfirmation(order);
        }
    }

    sendConfirmation(order, fromConfirm?) {
        this.Orders.sendConfirmationMail({
            orderNumber: order.orderNo
        }, {}).$promise.then(() => {
                if (fromConfirm) {
                    this.toastService.showSimpleToast('Ordren er bekreftet og sendt', 3000);
                } else {
                    this.toastService.showSimpleToast('Bekreftelse sendt', 3000);
                }
            }, (error) => {
                this.toastService.parseError(error);
            }
        );


    }

    confirmOrSend(event, order) {
        const view = this;

        this.$mdDialog.show({
            template: '<rkc-order-handling modal-instance="c.modalInstance" order="c.order"></rkc-order-handling>',
            controllerAs: 'c',
            controller: <any>['$mdDialog', function ($mdDialog) {
                this.modalInstance = $mdDialog;
                this.order = order;
            }],
            targetEvent: event,
            clickOutsideToClose: true
        })
            .then(function (action) {
                view.handleAction(action, order);
            }, function () {
            });
    }
}

class TableOptions implements ng.IComponentOptions {
    bindings: any = {
        tableContent: '=',
        tableDefinition: '=',
        tableTitle: '=',
        minimizedOnInit: '='
    };
    controller: string = 'rkcOrdersTableController';
    controllerAs: string = 'c';
    template: any = require('./ordersTable.html');
}

rkcApp.controller("rkcOrdersTableController", ['toastService', '$scope', '$location', 'Orders', '$filter', '$state', '$mdDialog', function (toastService, $scope, $location, Orders, $filter, $state, $mdDialog) {
    return new OrdersTableController(toastService, $scope, $location, Orders, $filter, $state, $mdDialog);
}])
    .component("rkcOrdersTable", new TableOptions());



/** WEBPACK FOOTER **
 ** ./src/app/components/main/views/orders/ordersTable/ordersTable.ts
 **/